<template>
	<v-sheet>
        <MwList storeModule="questionTemplates" :columns="headers">
        </MwList>
    </v-sheet>
</template>

<script type="text/javascript">
import MwList from "@c/ui/MwList";
export default {
	name: "QuestionTemplates",
    data: () => {
        return {
            filtered: false
        }
    },
	computed: {
		headers() {
			return [
				{value: "name", text: "Name", default: true},
			];
		},
	},
	components: {
		MwList
	},
};
</script>

